import PublicIcon from "@mui/icons-material/Public";
import { Box, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { Images } from "../../../assets";
import { ColumnBox, RowBox } from "../../../utils/styledBox";
import ButtonAI from "./ButtonAI";

const DeepResearch = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box sx={{ width: "100%" }}>
      <ColumnBox>
        {/* DeepResearch */}
        <RowBox sx={{ height: 48 }}>
          <Typography
            variant={"h6"}
            component={"h3"}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <PublicIcon sx={{ color: theme.palette.secondary.main, mr: 2 }} />
            {t("drawer.deepResearch")}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
        </RowBox>
        <ButtonAI
          title={t("drawer.deepResearch")}
          icon={<PublicIcon />}
          path={"/deep-research"}
          image={Images.dashBoard.deepResearch}
        />
      </ColumnBox>
    </Box>
  );
};
export default DeepResearch;
